$.ajaxSetup({
	data: {
		SystemPartner: ym.options.name,
		SecurityID: ym.options.securityID,
		Channel: ym.options.channel,
		IsoCountryCode: ym.options.isoCountryCode || 'DE',
		IsoLocale: ym.options.isoLocale || 'de-DE',
		Addition: 'Database=YM_FILIALEN',
		Top: config.Top
	}
});

function initializeResults() {
	window.signals = new CEventEmitter();

	var search = new ym.geo.CSearch();
	window.searchSignals = new CSearchSignals(search, map, signals);
	var mapSignals = new CMapSignals(map, signals);

	function registerResultClickEvent() {
		$('.resultlist > li').click(function (e) {
			var contact = $(e.target).data('contact');
			if (contact !== 'url' && contact !== 'email') {
				var href = $(this).data('href');
				window.location = href;
			}
		});
	}

	function renderPager(id) {
		var pagingModel = new PagingModel();
		pagingModel.fromResultList(resultListModel, config);

		var pagingView = new PagingView({
			el: id,
			model: pagingModel
		});
		pagingView.render();
	}

	var config = module.config(),
		resultListModel = new ResultListModel(),
		firstSearchCompleted = false,
		resultListView;

	var currentPage = 1;
	var lastPage = 1;
	var isLocationSearch = true;
	var lockMapSearch = false;
	var searchMode;
	var searchCenter;

	searchView.setTextTransformer(ym.util.formatAddressLine);

	$('#Search_SearchMode-poi-search').click(function () {
		searchView.enableTypeahead();
		searchMode = $(this).val();
		isLocationSearch = true;
	});

	$('#Search_SearchMode-fulltext-search').click(function () {
		searchView.disableTypeahead();
		searchMode = $(this).val();
		isLocationSearch = false;
	});

	$(document).on('click', '.details-link', function (e) {
		sessionStorage.search = location.search;
	});

	$(document).on('click', '.searchMoreButton', function (e) {
		e.preventDefault();
		currentPage = currentPage || $(this).data('currentPage');
		lastPage = lastPage || $(this).data('lastPage');
		isLocationSearch = true;
		lockMapSearch = true;

		resultListView.isLocationSearch = isLocationSearch;

		var mapView = new MapView({
			model: resultListModel,
			isInit: true,
			map: map,
			search: search,
			config: config,
			searchCenter: searchCenter
		});

		if (currentPage < lastPage) {
			currentPage++;
			//erste Suche ist Umkreissuche damit wir Umkreis ggf. erweitern können
			lockMove = true;
			// searchSignals.useCache();

			searchSignals.searchAtLocationByBranchCode(mapView.options.config.BranchCodes, {
				ZoomLevel: map.getZoomLevel(),
				MaxRadius: -1,
				Top: mapView.options.config.Top,
				Page: currentPage
			});

			mapView.render();
		}
		if (currentPage >= lastPage) {
			$('.searchMoreButton').hide();
		}
	});

	$(document).on('click', '.externalRouteLink', function (e) {
		if (window.innerWidth < 768) {
			e.preventDefault();
			window.open($(this).attr('data-mobile-href'));
		}
	});

	// Wenn die Map zum ersten Mal geladen wurde,
	// soll ein Event ausgelöst werden, dass künftig
	// immer eine Suche startet, sobald die Karte
	// bewegt wurde. Kein Timeout nötig :)
	signals.once('maploaded', function () {
		$('#result-list').removeClass('first-load-hide');

		if (resultListView) {
			resultlistView.$el.empty();
		}

		resultListView = new ResultListView({
			el: '#result-list',
			model: resultListModel,
			isLocationSearch: true,
			searchMode: searchMode
		});
		resultListView.$el.empty();

		isLocationSearch = true;
		lockMapSearch = true;

		var mapView = new MapView({
			model: resultListModel,
			isInit: true,
			map: map,
			search: search,
			config: config
		});

		searchMode = $('[name="Search.SearchMode"]:checked').val();
		if (searchMode === 'FULLTEXT_SEARCH') {
			isLocationSearch = false;
			ym.BaseValues.defaultSearchMode = 'fulltext';
			searchView.disableTypeahead();

			lockMove = true;
			searchSignals.searchFulltext(mapView.options.config.BranchCodes, $('#Search_SingleSlotGeo').val());
		} else {
			ym.BaseValues.defaultSearchMode = 'location';
			//erste Suche ist Umkreissuche damit wir Umkreis ggf. erweitern können
			lockMove = true;
			searchSignals.searchAtLocationByBranchCode(mapView.options.config.BranchCodes, {
				ZoomLevel: map.getZoomLevel(),
				MaxRadius: -1,
				Top: mapView.options.config.Top,
				Page: currentPage
			});
		}

		mapView.render();
		registerResultClickEvent();

		$(window).resize(function () {
			if (map) {
				//Wenn es eine Karte gibt, informieren wir sie hier über ein Resizing.
				var map_container = $('#' + config.Container);
				var width = map_container.width();
				var height = map_container.height();
				map.resizeMap(new ym.common.CSize(width, height));
			}
		});
	});

	signals.on('searchsuccess', function (data) {
		// searchSignals.unuseCache();

		var myCenterMarker = _.find(map.MapObj.Markers, function (marker) {
			return marker.LayerID === 'CenterMarker';
		});

		if (!isLocationSearch) {
			map.removeAllMarkers('FilialLayer');
		} else {
			searchCenter = ym.g(data.SearchData.Location.YCoord, data.SearchData.Location.XCoord);
			myCenterMarker = CenterMarker(searchCenter);
		}

		lastPage = +data.Paging.MaxPage;
		currentPage = +data.Paging.Page;

		// Erstelle die Address-Liste aus dem JSON-Objekt
		resultListModel = new ResultListModel();
		resultListModel.fromJSON(data);
		resultListView.isLocationSearch = isLocationSearch;
		resultListView.setSearchMode(searchMode);
		resultListView.render();

		var mapView = new MapView({
			model: resultListModel,
			isInit: false,
			map: map,
			search: search,
			config: config,
			searchCenter: myCenterMarker
		});
		mapView.render();

		renderPager('#content-pagination-bottom');

		registerResultClickEvent();
		//registerQRCodeHover();

		//neue Suche registrieren, wenn Karte bewegt wurde
		if (!firstSearchCompleted) {
			if (mapView.Markers && mapView.Markers.length > 0) {
				mapView.options.map.optimizeMapForResult(mapView.Markers, 40);
			}

			mapView.options.isInit = true;
			mapView.render();

			setTimeout(function () {
				signals.on('mapendmove', function (currentMap) {
					if (lockMapSearch) {
						lockMapSearch = false;
					} else {
						ym.BaseValues.defaultSearchMode = 'area';
						currentPage = 1;
						searchMode = $('[name="Search.SearchMode"]:checked').val();
						if (searchMode !== 'FULLTEXT_SEARCH') {
							lockMove = true;
							isLocationSearch = false;
							searchSignals.searchInAreaByBranchCode(mapView.options.config.BranchCodes, {
								Addition: encodeURIComponent(
									'Database=YM_FILIALEN&' +
										'LocXForDistanceCalculation=' +
										searchCenter.Longitude +
										'&' +
										'LocYForDistanceCalculation=' +
										searchCenter.Latitude
								),
								ZoomLevel: currentMap.getZoomLevel(),
								Top: mapView.options.config.Top,
								Page: currentPage
							});
						}
					}
				});
			}, 1000);
			firstSearchCompleted = true;
		}
	});

	searchView.render();
	map.loadMap();
}

ym.ready({ autocomplete: 5 }, function () {
	if (!ym.modules.autoComplete && sm.autocomplete.v5) {
		ym.modules.autoComplete = sm.autocomplete.v5.autoComplete;
	}
	initializeMap();
	initializeResultListModel();
	initializeResults();
});
